import { PatientFormScreen } from "~/session/patient-form/patient-form-screen";

// /session/:id/patient/new — add a patient to the handover (E4.1). Access is
// limited to the session's outgoing doctor on a draft/active session; the
// shared screen resolves that and renders the form or the right gate state.
export default function NewPatientRoute(): JSX.Element {
  return <PatientFormScreen mode="create" />;
}
